<div class="carousel-card">

    <div class="card-header">
        <h4>{{ cardData?.parsedObjectData?.['Service']}}</h4> 
         <button mat-button1 title="Click Pin to make it default" *ngIf="!checkDefaultPinService() && !cardData?.apiFailed" (click)="makeDefaultService(cardData?.parsedObjectData?.['Service'])" >
             <span><i class="fa-solid fa-thumbtack"></i></span></button>
    
          <button mat-button1 title="Default Service" *ngIf="checkDefaultPinService() && !cardData?.apiFailed">
              <span><i class="fa-solid fa-thumbtack green"></i></span></button>
        
        <section *ngIf="cardData?.apiFailed && !cardData?.parsingError" class="error-wrapper" >
            <f-alert variant="error">
              <!-- <p>There was a problem setting your default service.Click the pin to try again.</p> -->
              <p>There was a problem loading the data. 
                  <a (click)="onRefreshClickAction()">Try again </a></p> 

            </f-alert>
        </section>

        <section *ngIf="cardData?.parsingError" class="error-wrapper" >
            <f-alert variant="error">
              <p>There is an issue with the configuration of the client data.  Please contact the Support Team for assistance.</p> 

            </f-alert>
        </section>
    </div>    

    <div class="card-detail" *ngIf="!cardData?.apiFailed">
        <p><strong>Service info:</strong></p>
        <p>{{ cardData?.parsedObjectData?.['Service Center Name'] }}</p> 
        <p> {{ cardData?.parsedObjectData?.['Phone']}}</p>
        <p> {{ cardData?.parsedObjectData?.['URL']}} </p>
    </div>

    <div class="card-detail" *ngIf="!cardData?.apiFailed">
    <p><strong>Greeting:</strong></p>
    <p> {{  getGreeting(cardData?.parsedObjectData?.['Greeting'] ,  cardData?.parsedObjectData?.['Service Center Name'])}} </p>
    </div>
    
    <div class="card-detail" *ngIf="!cardData?.apiFailed">
    <p><strong>Terminology for Employees:</strong></p>
    <p> {{ cardData?.parsedObjectData?.['Title']}}</p>  
    </div>

</div>